import { FC, useMemo, useEffect, useState, useRef } from 'react';
import './CustomFilterSelect.scss';
import { SearchSvg } from '../../svgs/Svgs';
import { Form } from 'react-bootstrap';
import { preventEnterKey } from '../../../../utils/commonFunctions';
import { OptionType, SelectedFilter } from '../types';
import { FilterDropdownArrowSvg } from '../../../command_center/components/center/modals/console/ConsoleSvg';
import CustomToolTip from '../../CustomToolTip';

interface CustomFilterSelectProps {
    activeSearch?: boolean;
    multiSelection?: boolean;
    placement?: 'left' | 'right';
    options: OptionType[];
    placeholder: string;
    onSelect: (value: any) => void;
    selectedValue: string | string[] | null;
    disabled?: boolean;
    setOpenOptions: (value: 'Property' | 'Operator' | 'Value' | null) => void;
    openOptions: 'Property' | 'Operator' | 'Value' | null;
    selectedFilter: SelectedFilter | null;
}

const CustomFilterSelect: FC<CustomFilterSelectProps> = ({ activeSearch, placement = 'left', options, placeholder, onSelect, selectedValue, multiSelection, disabled, setOpenOptions, openOptions, selectedFilter }) => {

    const updatedOptions = useMemo(() => Array.isArray(options) ? options : [], [options])
    const value = useMemo(() => Array.isArray(selectedValue) ? `${placeholder}(${selectedValue?.length})` : selectedValue, [selectedValue, placeholder])
    const filterOptions = useMemo(() =>
        multiSelection
            ? updatedOptions
            : Array.isArray(selectedValue)
                ? updatedOptions.filter(op => !selectedValue.includes(op.label))
                : updatedOptions.filter(op => op.label !== selectedValue),
        [updatedOptions, selectedValue, multiSelection])

    const [searchText, setSearchText] = useState('')
    const [optionsAfterSearch, setOptionsAfterSearch] = useState<OptionType[]>([])

    const optionsRef = useRef<HTMLDivElement>(null)
    const dropdownRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const filteredOptions =
            searchText !== '' && searchText !== null
                ? filterOptions?.filter((option) =>
                    String(option.label).toLowerCase().includes(searchText.toLowerCase())
                )
                : filterOptions;
        setOptionsAfterSearch(filteredOptions)
    }, [searchText, filterOptions])


    const handleSearch = (e) => {
        //search property
        setSearchText(e.target.value)
    }

    const handleOpenOptions = () => {
        if (disabled) {
            setOpenOptions(null)
            return
        }

        if (placeholder === 'Property') {
            setOpenOptions(openOptions === 'Property' ? null : 'Property');
        } else if (placeholder === 'Operator') {
            setOpenOptions(openOptions === 'Operator' ? null : 'Operator');
        } else if (placeholder === 'Value') {
            setOpenOptions(openOptions === 'Value' ? null : 'Value');
        }
    };

    useEffect(() => {
        if (openOptions) setSearchText('')
    }, [openOptions])

    const renderFilterHeader = () => {
        const isPlaceholder = placeholder === 'Value';

        // Tooltip text (from selectedFilter)
        const tooltipTitle = Array.isArray(selectedFilter?.value)
            ? selectedFilter.value.join(", ")
            : selectedFilter?.value || "";

        // Main <div> content
        const content = (
            <div className={`custom__filter__select__header ${disabled ? 'disabled' : 'not_disabled'}`} onClick={handleOpenOptions}>
                <span className='custom__filter__select__header__text'>{value || placeholder}</span>
                <FilterDropdownArrowSvg />
            </div>
        );

        //Content for text field
        const contentForTheValueSelect = (
            <div
                className="select-header-wrapper"
                onClick={handleOpenOptions}
                style={{ width: "100%" }} // make it stretch full
            >
                <CustomToolTip title={tooltipTitle}>
                    <div className={`custom__filter__select__header ${disabled ? "disabled" : "not_disabled"}`}>
                        <span className="custom__filter__select__header__text" style={{overflow: 'visible', }}>{value || placeholder}</span>
                    </div>
                </CustomToolTip>
                <FilterDropdownArrowSvg />
            </div>
        );

        // Return with or without tooltip
        return (!isPlaceholder || !selectedFilter?.value || selectedFilter?.value?.length === 0) ? content : contentForTheValueSelect;
    };
      
    return (
        <div className={`custom__filter__select ${openOptions === placeholder ? ' active' : ''}`} ref={dropdownRef}>
            {renderFilterHeader()}
            <div className={`custom__filter__select__body place__${placement}`} ref={optionsRef}>
                <div className={`custom__filter__select__body__search__container ${activeSearch && 'active__search'}`}>
                    <span className='custom__filter__select__body__search__icon'>
                        <SearchSvg />
                    </span>
                    <input type='text' className='custom__filter__select__body__search__input' placeholder={placeholder} value={searchText} onChange={handleSearch} />
                </div>
                <div className='custom__filter__options__height'>
                    {optionsAfterSearch.map(option => {
                        const label: string | number = option.label
                        return (
                            <button className='custom__filter__select__body__item' key={option.label}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onSelect(option)
                                    if (!multiSelection) {
                                        setOpenOptions(null)
                                    }
                                }}
                            >
                                <span className={`custom__filter__select__body__item__icon ${multiSelection && 'show__icon'}`}>
                                    <Form.Check
                                        type={"checkbox"}
                                        className="h-5 custom-checkbox-option-selection"
                                        checked={
                                            Array.isArray(selectedFilter?.value)
                                                ? selectedFilter.value.some((v) => v === label)
                                                : selectedFilter?.value === label
                                        }
                                        onKeyDown={preventEnterKey}
                                    />
                                </span>
                                <span className='custom__filter__select__body__item__text' title={`${label}`}>{option.label}</span>
                            </button>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default CustomFilterSelect